module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.0.0.box.174.613.1347.196.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.20.0.0.box.522.613.641.79.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  }), _vm._v("The Theriots:")]), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.6.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.7.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.8.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.9.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.10.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.12.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.3.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.3.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "font-variant": "small-caps"
    },
    attrs: {
      "id": "para.20.0.1.box.174.711.1347.98.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.0.0"
    }
  }), _vm._v("One Cajun Family'"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.0.0"
    }
  }), _vm._v("s Ancestry")]), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.2.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.4.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.20.1.0.box.172.1095.1355.1190.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.4.1.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.4.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0009.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.4.2.0.1"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.4.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.5.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.21.0.0.box.170.267.1353.1467.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0010.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.2"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b168fbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0011.vue
// module id = 63
// module chunks = 0